<template>
    <div>
        <template v-if="employeeLeaves">
            <div class="page-top mb-1 mb-3 clearfix">
                <h1 class="float-left">Leaves Applications</h1>
            </div>
          <div class="row">

            <div class="col-md-3">
              <div class="form-group">
                <label class="label block-label"> From Date </label>
                <datepicker name="from_date" v-model="from_date" input-class="datepicker" :bootstrap-styling="true" placeholder="From Date"></datepicker>
              </div>
            </div>

            <div class="col-md-3">
              <div class="form-group">
                <label class="label block-label"> To Date </label>
                <datepicker name="to_date" v-model="to_date" input-class="datepicker" :bootstrap-styling="true" placeholder="To Date"></datepicker>
              </div>
            </div>

            <div class="col-md-3">
              <div class="form-group">
                <label class="label block-label"> Status </label>
                <select class="selectpicker custom-select2" v-model="leave_status">
                  <option value="" selected> Select Status </option>
                  <option value="PENDING"> PENDING </option>
                  <option value="APPROVED_TL"> APPROVED TL </option>
                  <option value="APPROVED_HR"> APPROVED HR </option>
                  <option value="REJECTED_TL"> REJECTED TL </option>
                  <option value="REJECTED_HR"> REJECTED HR </option>
                </select>
              </div>
            </div>

            <div class="col-md-3">
              <div class="form-group">
                <label class="label block-label">Type</label>
                <select name="leave_type" id="leave_type" class="selectpicker custom-select2" v-model="leave_type" >
                  <option value="">Select Leave Type </option>
                  <template v-if="companiesLeaves != null">
                    <option
                        v-for="companyLeave in companiesLeaves"
                        :key="companyLeave.id" :data-id="companyLeave.id"
                        :value="companyLeave.id" >
                      {{companyLeave.title}}
                    </option>
                  </template>
                </select>
              </div>
            </div>

            <div class="col-md-12">
              <div class="form-group text-right">
                <button class="btn btn-primary" @click="filterTable">Search</button>
              </div>
            </div>
          </div>
            <div class="table">
                <table id="leavesTable" class="table" width="100%">
                    <thead>
                        <tr>
                            <th>Applicant Name</th>
                            <!-- <th>Team Manager</th> -->
                            <th>Date</th>
                            <th>Leave Type</th>
                            <th>Status</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                </table>
            </div>
        </template>
        <template v-else-if="employeeLeaves == null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="employeeLeaves == false">
            Sorry this page is not accessable!
        </template>
    </div>
</template>

<script>
    var dtTable = null;
    export default {
        data() {
            return {
              employeeLeaves:true,
              from_date:'',
              to_date:'',
              leave_status:'',
              leave_type:'',
              companiesLeaves:null,
            };
        },
        mounted() {
            this.$Progress.start();
            this.getPermission();

        },
        methods: {
          filterTable(){
            this.$Progress.start();
            this.dtTable.draw();
            this.$Progress.finish();
          },
            getPermission(){
                var self =this;
                axios.get('/api/getPermission')
                    .then(res => {
                        if(res.status == 200){
                            if (res.data) {
                                self.employeeLeaves = res.data;
                                self.getEmployeeLeaves();
                                self.getCompaniesLeaves();
                            }else{
                                self.employeeLeaves = res.data;
                            }
                        }else{
                            self.$Progress.fail();
                            self.showAlertBox('error','Error Loading Permission');
                        }
                    })
                    .catch(err => {
                        $(self.$el).find('.selectpicker').selectpicker('refresh');
                        self.showAlertBox('error','Some error in network');
                    });
            },
            getEmployeeLeaves: function(){
                var that = this;
              that.dtTable = $('#leavesTable').DataTable({
                    processing: true,
                    serverSide: true,
                    searching: true,
                    sDom: '<"row pb-3 view-filter"<"col-md-12 pr-4 pl-4 text-right"f>><"table-holder mb-3"t><"row mb-3 view-pager"<"col-sm-4 pl-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 pr-4 text-right"l>>r',
                    ajax: {
                        "url": "api/getEmployeeleaves",
                        "data": function (d) {
                          d.from_date = moment(that.from_date).format('YYYY-MM-DD');
                          d.to_date = moment(that.to_date).format('YYYY-MM-DD');
                          d.leave_status = that.leave_status;
                          d.leave_type = that.leave_type;
                        },
                        "headers": window.axios.defaults.headers.common,
                        "dataSrc": "records",
                        "complete": function (json, type) { //type return "success" or "parsererror"
                            if (type == "parsererror") {
                                that.$Progress.fail();
                            }else{
                                that.$Progress.finish();
                            }
                        }
                    },
                    deferRender: true,
                    columns: [
                        {data:'name', render: function(data,type,full){
                            if(full.user){ return full.user.name; }
                            else{ return '------------'; }
                        } },
                        // {data:'line_manager', render: function(data,type,full){
                        //     if(full.line_manager){ return full.line_manager.name; }
                        //     else{ return '------------'; }
                        // } },
                        {data: 'created_at', render: function(data,type,full){
                            return moment(full.created_at).format('YYYY-MM-DD hh:mm A');
                        } },
                        {data: 'leave_type'},
                        {data: 'leave_status'},
                        {data: 'id', sorting: false, render: function(data,type,full){
                            var $url = '/viewLeaveApplication/'+full['id'];
                            return '<a href="javascript:void(0);" onclick="window.vueRouterPush(\''+$url+'\')" data-toggle="tooltip" data-placement="top" title="" class="action view" data-original-title="View"><i class="fas fa-eye"></i></a>';
                        }},
                    ],
                    "order": [[ 0, "desc" ]],
                });
            },
            getCompaniesLeaves(){
                let t = this;
              axios.get('api/companyLeavesList')
                  .then(res => {
                    if(res.data.record.length>0){
                      this.companiesLeaves = res.data.record;
                    }
                  }).then(result => {
                  $(this.$el).find('.selectpicker').selectpicker('refresh');
              });
            }
        },
        created() {
        }
    }
</script>
